<template>
  <div >
    <div id="cg-navbar">
      <div class="logo" @click.prevent="goTo('home')">
        <img src="@assets/img/logo/white.png" alt="couchgourmet">
      </div>
      <div class="navigation">
        <div class="icon-text white login" v-if="!isAuthenticated">
          <div class="icon circle white" @click.prevent="toggleLoginModal">
            <icon name="user" class="icon"></icon>
          </div>
          <span @click.prevent="toggleLoginModal" class="name">Anmelden</span>
        </div>

        <div class="icon circle white shopping-cart" v-if="isAuthenticated" @click.prevent="goTo('cart')">
          <span class="badge">{{ cartItemCounter }}</span>
          <icon name="shopping-cart" class="icon"></icon>
        </div>

        <div class="account-menu" v-if="isAuthenticated">
          <div class="icon-text white">
            <div class="icon circle white">
              <icon name="user" class="icon"></icon>
            </div>
            <span class="name">{{ account.first_name + ' ' + account.last_name }}</span>
          </div>
          <div class="dropdown">
            <div class="dropdown-arrow"></div>
            <div class="list">
              <span><a href="#" @click.prevent="goTo('profile')">Profil</a></span>
              <span><a href="#" @click.prevent="logout">Logout</a></span>
            </div>
          </div>
        </div>

      </div>

      <div class="icon-text white login-md" v-if="!isAuthenticated">
        <div class="icon circle white" @click.prevent="toggleLoginModal">
          <icon name="user" class="icon"></icon>
        </div>
        <span @click.prevent="toggleLoginModal" class="name">Anmelden</span>
      </div>

      <div class="icon circle white shopping-cart-md" v-if="isAuthenticated" @click.prevent="goTo('cart')">
        <span class="badge">{{ cartItemCounter }}</span>
        <icon name="shopping-cart" class="icon"></icon>
      </div>
    </div>
  </div>

</template>

<script>
  import helpers from '@/mixins/helpers.js'
  import { EventBus } from '@/assets/js/event-bus.js'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    name: 'navbar',
    mixins: [helpers],
    methods: {
      ...mapActions([
        'logout'
      ]),
      toggleLoginModal () {
        EventBus.$emit('toggleLoginModal')
      },
      toggleRegisterModal () {
        EventBus.$emit('toggleRegisterModal')
      }
    },
    computed: {
      ...mapGetters({
        account: 'auth_get_account',
        isAuthenticated: 'auth_is_authenticated',
        cartItemCounter: 'user_get_cartItem_counter'
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Navbar.vue